exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner[data-v-41e67f66] {\n  margin-bottom: var(--size-lg);\n}\n.banner__content[data-v-41e67f66] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-md);\n}\n.banner__content > p[data-v-41e67f66] {\n  margin: 0;\n}\n.banner__list[data-v-41e67f66] {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}", ""]);

// exports
